import { reactive, provide, inject } from 'vue';
import { PsProvider } from '../core/PsProvider';
import PsApiService from '@/api/PsApiService';
import Product from '@/object/coinHolder';
import PsResource from '@/api/common/PsResource';

export class GetCoinProvider extends PsProvider {

    isNoMoreRecord = reactive<Boolean>(false);
    GetCoinList = reactive<PsResource<Product[]>>(new PsResource());
    item = reactive<PsResource<Product>>(new PsResource());
    loading = reactive({
        value: false
    });

    limit: Number = 10;
    offset: Number = 0;

    id: string = "";
  static GetCoinList: any;

    private updateItemList(responseData: PsResource<Product[]>) {

        if (this.GetCoinList != null
            && this.GetCoinList.data != null
            && this.GetCoinList.data.length > 0
            && this.offset != 0) {

            if (responseData.data != null && responseData.data.length > 0) {
                this.GetCoinList.data.push(...responseData.data);
            }else {
                this.isNoMoreRecord = true;
            }
            this.GetCoinList.code = responseData.code;
            this.GetCoinList.status = responseData.status;
            this.GetCoinList.message = responseData.message;

        } else {

            this.GetCoinList = responseData;


        }

        if (this.GetCoinList != null && this.GetCoinList.data != null) {
            this.offset = this.GetCoinList.data.length;
        }

    }

    async loadCoin(loginUserId: string) {

        this.loading.value = true;
        
        const responseData = await PsApiService.getCoin<Product>(new Product(), loginUserId);
    this.updateItemList(responseData)
        this.loading.value = false;

        return responseData;

    }    
    async coinRequest(coin: string,loginUserId: string) {

        this.loading.value = true;
        
        const responseData = await PsApiService.sendCoinRequest<Product>(new Product(), coin,loginUserId);

        this.loading.value = false;

        return responseData;

    }
    
}

export const GetCoinProviderSymbol = Symbol('GetCoinProvider')
export const createGetCoinProviderState = () => {
    return reactive(new GetCoinProvider())
}
export const loadGetCoinList = () => {
    return reactive(new GetCoinProvider())
}

export const useGetCoinProviderState = () => inject(GetCoinProviderSymbol) as GetCoinProvider
export const provideGetCoinProviderState = () => provide(
    GetCoinProviderSymbol,
    createGetCoinProviderState()
)